/**
 * Функция создания глобального тега для кроссмодульной инвалидации кеша.
 * @param tag Название тега
 * @returns Название глобального тега
 * @public
 */
export function createGlobalInvalidationTag<T extends string>(tag: T) {
    return `global:${tag}` as const;
}
